(function () {
    'use strict';

    /**
     * Generic login controller
     */
    angular.module('app').controller('LoginController', LoginController);

    LoginController.$inject = ['$scope', 'settingsService', 'codesService', 'translationsService', 'loadingIndicatorService', '$timeout'];
    function LoginController($scope, settingsService, codesService, translationsService, loadingIndicatorService, $timeout) {
        codesService.loadAllCodes();

        translationsService.loadTranslations((translations) => {
            $scope.translations = translations;

            loadingIndicatorService.SetLoadingState(false);
        });

        $scope.settings = settingsService;

        $scope.showLoginDiv = () => settingsService.showLogin;

        $scope.ClearCache = clearCache;
        function clearCache() {
            localStorage.clear();
        }

        const imageModalContext = {
            Modal: null
        };

        $scope.OnNewsReady = function () {
            $timeout(function () {
                // Capture reference to the modal1
                imageModalContext.Modal = $('#image-modal');

                const images = $('news-item img');

                // Register click handler for all images inside a newsitem
                images.on('click', handleClick);

                images.attr('data-toggle', 'modal');
                images.attr('data-target', '#image-modal');

            }, 15, false);
        };

        function handleClick(event) {
            const clickedImage = event.currentTarget;

            imageModalContext.Modal.children("img")[0].src = clickedImage.src;
        }
    }
})();